import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from './LanguageContext';
import { PackageIcon, CreditCardIcon, CalendarCheckIcon, TruckIcon } from 'lucide-react';
const STEPS = [{
  icon: PackageIcon
}, {
  icon: CreditCardIcon
}, {
  icon: CalendarCheckIcon
}, {
  icon: TruckIcon
}];
export function HowItWorks() {
  const {
    t
  } = useLanguage();
  return <section id="how-it-works" className="py-20 bg-brand-dark relative overflow-hidden" data-id="element-461">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-462">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-14" data-id="element-463">
          <p className="text-brand-red font-oswald text-sm tracking-[0.3em] uppercase mb-3" data-id="element-464">
            Simple Process
          </p>
          <h2 className="font-oswald text-4xl md:text-5xl font-bold text-white uppercase" data-id="element-465">
            {t.howItWorks.title}
          </h2>
        </motion.div>

        {/* Compact horizontal steps */}
        <div className="relative" data-id="element-466">
          {/* Connecting line — desktop */}
          <div className="hidden lg:block absolute top-[28px] left-[10%] right-[10%] z-0" data-id="element-467">
            <div className="h-[2px] w-full bg-white/5" data-id="element-468">
              <motion.div initial={{
              scaleX: 0
            }} whileInView={{
              scaleX: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 1.2,
              ease: 'easeInOut'
            }} className="h-full bg-gradient-to-r from-brand-red/30 via-brand-yellow/20 to-brand-red/30 origin-left" data-id="element-469" />
            </div>
          </div>

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6" data-id="element-470">
            {t.howItWorks.steps.map((step: any, index: number) => {
            const StepIcon = STEPS[index].icon;
            const isEven = index % 2 === 0;
            const accentColor = isEven ? 'brand-red' : 'brand-yellow';
            return <motion.div key={index} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: index * 0.1
            }} className="relative z-10 text-center" data-id="element-471">
                  {/* Icon circle */}
                  <div className="flex justify-center mb-4" data-id="element-472">
                    <div className={`relative w-14 h-14 rounded-full bg-${accentColor}/10 flex items-center justify-center`} data-id="element-473">
                      <StepIcon className={`w-6 h-6 text-${accentColor}`} strokeWidth={1.5} data-id="element-474" />
                      <div className={`absolute -top-1 -right-1 w-6 h-6 rounded-full ${isEven ? 'bg-brand-red' : 'bg-brand-yellow'} flex items-center justify-center font-oswald font-bold text-xs ${isEven ? 'text-white' : 'text-brand-black'}`} data-id="element-475">
                        {index + 1}
                      </div>
                    </div>
                  </div>

                  <h3 className="font-oswald text-base font-bold text-white mb-1.5 uppercase tracking-wide" data-id="element-476">
                    {step.title}
                  </h3>
                  <p className="text-gray-500 text-xs leading-relaxed max-w-[200px] mx-auto" data-id="element-477">
                    {step.desc}
                  </p>
                </motion.div>;
          })}
          </div>
        </div>

        {/* Compact photo strip */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="mt-14 relative rounded-xl overflow-hidden" data-id="element-478">
          <img src="https://cdn.magicpatterns.com/uploads/n4o3uAc1tAA8fRLhdUe3rx/hf_20260422_174623_897fe614-de8b-463c-ae04-a1b25719c577.png" alt="Move Fighters team with happy family" className="w-full h-[200px] md:h-[260px] object-cover" data-id="element-479" />
          <div className="absolute inset-0 bg-gradient-to-r from-brand-black/80 via-brand-black/40 to-transparent" data-id="element-480" />
          <div className="absolute inset-0 flex items-center px-6 md:px-12" data-id="element-481">
            <div data-id="element-482">
              <p className="font-oswald text-2xl md:text-3xl font-bold text-white uppercase" data-id="element-483">
                Your Move, Our Mission
              </p>
              <p className="text-gray-300 text-sm mt-1" data-id="element-484">
                Every rescue ends with a handshake and a smile.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}